import { useTheme } from "@/context/ThemeContext";
import { Moon, Sun } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      className={`inline-flex items-center justify-center min-h-[44px] min-w-[44px] rounded-lg text-slate-600 hover:bg-slate-100 dark:text-cream-200 dark:hover:bg-slate-800 transition-colors ${className}`}
      data-testid="theme-toggle-btn"
      aria-label="تبديل الوضع"
      title={isDark ? "الوضع الفاتح" : "الوضع الليلي"}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
